export default "__VITE_ASSET__CTAnp9ax__"